import React from "react"
import { Row, Col } from "antd"
import styled from "styled-components"
import Fb from "../../../images/fb.png"
import Insta from "../../../images/insta.png"
import LinkedIn from "../../../images/linkedin.png"
import CBD1 from "../../../images/cbd1.png"
import CBD2 from "../../../images/cbd2.png"

const StyledSection = styled.div`
  padding-top: 1rem;
  padding-left: 3rem;
  padding-right: 3rem;
  h1 {
    font-size: 18px;
    line-height: 40px;
    color: #172315;
    font-weight: 400;
  }
  .social-icons {
    width: 25px;
    margin-left: 15px;
    cursor: pointer;
  }
  .logo-icons {
    width: 60px;
    margin-left: 25px;
    cursor: pointer;
  }
  .right-items {
    float: right;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.lg)} {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.md)} {
    .right-items {
      float: none;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.xs)} {
    h1 {
      font-size: 14px;
    }
  }
`

const LineBar = styled.div`
  margin-left: 3rem;
  margin-right: 3rem;
  width: 90%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.lightColor};

  ${({ theme: { down, breakpoints } }) => down(breakpoints.sm)} {
    width: 80%;
  }
`

const BottomBar = () => {
  const openInNewTab = url => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer")
    if (newWindow) newWindow.opener = null
  }
  return (
    <>
      <LineBar />
      <StyledSection>
        <Row gutter={[48, 24]}>
          <Col xs={24} sm={24} md={9}>
            <h1>© Copyright 2021 All Rights Reserved</h1>
          </Col>
          <Col xs={24} sm={24} md={6}>
            <div className="right-items">
              <img
                alt="fb"
                onClick={() =>
                  openInNewTab("https://www.facebook.com/ananda.remedium")
                }
                src={Fb}
                className="social-icons"
              />
              <img
                onClick={() =>
                  openInNewTab("https://www.instagram.com/ananda.remedium/")
                }
                alt="insta"
                src={Insta}
                className="social-icons"
              />
              <img
                alt="linkedin"
                onClick={() =>
                  openInNewTab(
                    "https://www.linkedin.com/company/ananda-remedium"
                  )
                }
                src={LinkedIn}
                className="social-icons"
              />
            </div>
          </Col>
          <Col xs={24} sm={24} md={9}>
            <div className="right-items">
              <img alt="cbd1" src={CBD1} className="logo-icons" />
              <img alt="cbd2" src={CBD2} className="logo-icons" />
              <img alt="cbd1" src={CBD1} className="logo-icons" />
              <img alt="cbd2" src={CBD2} className="logo-icons" />
            </div>
          </Col>
        </Row>
      </StyledSection>
    </>
  )
}

export default BottomBar
